import { CarteiraAdminReducer } from './carteiraAdmin/reducers/carteiraAdminReducers';
import { combineReducers } from "redux";

import { CarteiraBaseReducerList, RootStateBaseCarteira } from "domain/store/_carteira/carteiraBaseReducer";
import { DepositoReducer } from "./deposito/reducers/depositoReducer";
import { ExtratoReducer } from "./extrato/reducers/extratoReducer";
import { PagamentoReducer } from "./pagamento/reducers/pagamentoReducer";

// Estende o CarteiraBaseReducerList com os reducers específicos do projeto carteira
export const CarteiraReducerList = {
    ...CarteiraBaseReducerList,
    CarteiraAdminReducer,
    DepositoReducer,
    ExtratoReducer,
    PagamentoReducer,
};

const CarteiraReducer = combineReducers(CarteiraReducerList);

export type RootStateCarteira = RootStateBaseCarteira & ReturnType<typeof CarteiraReducer>;
